<script lang="ts" setup>
  import { getServiceName } from '@/utils/branding';
  import type { VBaseLayoutProps } from './types';

  const props = defineProps<VBaseLayoutProps>();
  const defaultTitle = getServiceName();

  watch(
    () => props.title,
    () => {
      useTitle(props.title ? `${props.title} | ${defaultTitle}` : defaultTitle);
    },
    { immediate: true },
  );
</script>

<template>
  <div>
    <slot />
    <VFeatureBadgeLayer />
  </div>
</template>
